import { IteratorResultSlots, Types } from '../../constants';
import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinSlotInstanceMemberValue } from '../BuiltinSlotInstanceMemberValue';
class IteratorResultInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('IteratorResult', new IteratorResultInterface());
    builtins.addGlobalMember('IteratorResult', 'done', new BuiltinSlotInstanceMemberValue(Types.IteratorResult, IteratorResultSlots.done));
    builtins.addGlobalMember('IteratorResult', 'value', new BuiltinSlotInstanceMemberValue(Types.IteratorResult, IteratorResultSlots.value));
};

//# sourceMappingURL=index.js.map
